import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  pagination: {
    borderBottom: 0,
    textAlign: 'right' as const,
    width: '100%'
  },
  paginationActions: {
    margin: 0,
  },
}))
